import React from 'react'
import classNames from 'classnames'

import { siteNames } from '../../../common/constants/siteList'

const siteTitles = {
  audiojungle: 'Stock Music and Audio',
  themeforest: 'Website Templates',
  videohive: 'Motion Graphics',
  graphicriver: 'Graphics, Vectors and Print',
  '3docean': '3D Models and Materials',
  codecanyon: 'Code, Plugins and Mobile',
  photodune: 'Stock Photography'
}

export default ({
  currentSite
}) => (
  <div className='site-header__sites fds-u-hide-extra-large-and-below'>
    <div className='header-sites'>
      <div className='grid-container -layout-wide'>
        <nav className='header-sites__container'>
          {
            siteNames.map((site, index) => {
              const isCurrentSite = site === currentSite
              const shouldHaveOsr = !isCurrentSite ? '?osr=tn' : ''
              const siteLink = `https://${site}.net/${shouldHaveOsr}`
              const linkClassName = classNames(
                `header-sites__site--${site}`,
                {
                  'is-active': isCurrentSite
                }
              )
              const siteTitle = siteTitles[site]
              return (
                <a
                  key={index}
                  href={siteLink}
                  className={linkClassName}
                  title={siteTitle}>
                  {site}
                </a>
              )
            })
          }
        </nav>
      </div>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./client/components/siteHeader/marketSiteMenu.js